import { notification } from 'antd';

import { MIN_MANAGER_PWD_CHAR_REQUIRED } from '../../../constants';
import { Role } from '../../../enum';
import {
  notifyMissingFields,
  validateAsAdmin,
  validateAsFirstAlertsRole,
  validateAsHighRole,
  validateAsSPManagerRole,
} from '../../../helpers/utils.helper';
import type { AdminManager } from './adminManagerSlice';

const phoneRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;

export const validateAdminManager = (adminManager: AdminManager, currentUserRole: Role | null) => {
  const missingRequiredFields = [];
  if (!adminManager.first_name) missingRequiredFields.push('first name');
  if (!adminManager.last_name) missingRequiredFields.push('last name');
  if (!adminManager.email) missingRequiredFields.push('email');
  if (!adminManager.mobile_phone) missingRequiredFields.push('mobile_phone');
  if (!adminManager.role) missingRequiredFields.push('role');
  if (adminManager.role === Role.MANAGER && (!adminManager.region_numbers || adminManager.region_numbers.length < 1))
    missingRequiredFields.push('regions');
  if (
    validateAsHighRole(currentUserRole) &&
    validateAsFirstAlertsRole(adminManager.role) &&
    !adminManager.first_alerts_community_id
  )
    missingRequiredFields.push('FirstAlerts community');
  if (
    validateAsAdmin(currentUserRole) &&
    validateAsSPManagerRole(adminManager.role) &&
    !adminManager.service_provider_organization_id
  )
    missingRequiredFields.push('service provider organization');
  if (validateAsAdmin(currentUserRole) && !adminManager.org_code) missingRequiredFields.push('organization');

  if (missingRequiredFields.length > 0) {
    return notifyMissingFields(missingRequiredFields);
  } else if (!adminManager.email?.match(/^[^@]+@[^@]+\.\w\w+$/g)) {
    notification.error({
      title: 'Invalid email',
      description: 'Please provide a valid email.',
    });
    return false;
  } else if (adminManager.mobile_phone && !adminManager.mobile_phone.match(phoneRegex)) {
    notification.error({
      title: 'Invalid mobile phone number',
      description: 'Please provide a valid mobile phone number.',
    });
    return false;
  } else if (!adminManager.id && adminManager.pass && adminManager.pass.length < MIN_MANAGER_PWD_CHAR_REQUIRED) {
    notification.error({
      title: 'Initial password is too short',
      description: `Please provide an initial password at least ${MIN_MANAGER_PWD_CHAR_REQUIRED} characters long.`,
    });
    return false;
  } else {
    return true;
  }
};
